import React, { Component } from 'react';

class List extends Component {
  state = { }

  componentWillMount() {
    let _state = {};
    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
    children.forEach(function(el, index) {
      _state[index] = {open: false }
    })
    this.setState(_state);
  }

  handleChildClick = (index, state) => {
    let _state = {};
    let previousActiveIdx = -1;
    Object.keys(state).forEach(function (el, index) {
      if (state[index].open) {
        previousActiveIdx = index;
      }
      _state[index] = { open: false };
    });
    if (index !== previousActiveIdx) {
      _state[index] = { open: true };
    }
    this.setState(_state);
  }
 
  render() {
   const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];
   const childrenWithProps = React.Children.map(children,
      (child, index) => {
        return React.cloneElement(child, {
                  key: index,
                  expanded: this.state[index].open,
                  // handleClick: this.handleChildClick.bind(this, index, this.state)
               })
      }
   );

    return (
      <div>{childrenWithProps}</div>
    ) 
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/List/List.jsx